import { GetBookingsForGuestRescheduleEndpoint } from '@kouto/types';

const buildReschedulableBookingsUrl = (
  cartId: string,
  {
    brandId,
    token,
    languageCode,
  }: {
    brandId: string;
    token: string | undefined;
    languageCode: string | undefined;
  },
) => {
  const url = GetBookingsForGuestRescheduleEndpoint.url({
    cartId,
    brandId,
    query: {
      token: token ?? '',
      languageCode: languageCode ?? '',
    },
  });

  return `${process.env.KOUTO_API_URL}/${url}`;
};

export default buildReschedulableBookingsUrl;
